import React from "react";
import { Flex, Text, Table } from "@mantine/core";
import styled from "styled-components";
import { formatNumber } from "../../utils/numberFormatting";
import colors from "../../designTokens/colors.esm";
import { useTranslation } from "react-i18next";
import { useIsMobile } from "../../hooks/useIsMobile";

 

const StyledTh = styled(Table.Th)`
  height: 56px;
`;

const StyledTd = styled(Table.Td)`
  height: 48px;
`;

export const PerformanceTable = ({ boxPlotData }) => {
  const { t } = useTranslation();
  const isMobile = useIsMobile("xl");

  const statsLabels = ["min", "avg", "max"];
  const metrics = ["views", "likes", "replies", "reposts"];

  return (
    <Flex
      p={isMobile ? "16" : "24"}
      direction="column"
      justify={"center"}
      gap={16}
      style={{
        height: "100%",
        overflow: "auto",
      }}
    >
      <Table>
        <Table.Thead>
          <Table.Tr>
            <StyledTh>
              <Text fw={700} size={isMobile ? "sm" : "lg"}>
                {t("common.value")}
              </Text>
            </StyledTh>
            {metrics.map((metric) => (
              <StyledTh key={metric}>
                <Text fw={700} size={isMobile ? "sm" : "lg"}>
                  {t(`common.${metric}`)}
                </Text>
              </StyledTh>
            ))}
          </Table.Tr>
        </Table.Thead>
        <Table.Tbody>
          {statsLabels.map((stat) => (
            <Table.Tr
              key={stat}
              style={{
                backgroundColor:
                  stat === "avg" ? colors.gray[9] : "transparent",
                border: "none",
              }}
            >
              <StyledTd>
                <Text
                  fw={500}
                  c={stat === "avg" ? "white" : "inherit"}
                  size={isMobile ? "sm" : "lg"}
                >
                  {t(`common.stats.${stat}`)}
                </Text>
              </StyledTd>
              {metrics.map((metric) => (
                <StyledTd key={metric}>
                  <Text
                    c={stat === "avg" ? "white" : "inherit"}
                    size={isMobile ? "sm" : "lg"}
                  >
                    {stat === "avg"
                      ? formatNumber(
                          boxPlotData[metric][stat].toFixed(2)
                        )
                      : formatNumber(boxPlotData[metric][stat])}
                  </Text>
                </StyledTd>
              ))}
            </Table.Tr>
          ))}
        </Table.Tbody>
      </Table>
    </Flex>
  );
};

export default PerformanceTable; 